<template>
  <div style="margin-left: 20">
    <div class="container">
      <div class="row">
        <table>
          <tr>
            <td>
              <h3 style="margin-top: 10; margin-left: 50">Report</h3>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <form id="form_id" ref="form" @submit.prevent="processForm">
      <div class="container">
        <div class="row">
          <table class="table-horizontal" width="100%" height="20">
            <tbody>
              <tr>
                <td><strong>Group Name</strong></td>
                <td v-if="groups.length === 1">
                  <input
                    class="mumbai grayout"
                    readonly="true"
                    v-model="group"
                    @change="onGroupChange"
                  />
                </td>
                <td v-else>
                  <select
                    class="mumbai"
                    v-model="group"
                    @change="onGroupChange"
                  >
                    <option selected>-Select-</option>
                    <option
                      v-for="group in groups"
                      v-bind:key="group.id"
                      v-bind:id="group"
                    >
                      {{ group }}
                    </option>
                  </select>
                </td>
                <td><strong>Function Supported</strong></td>
                <td>
                  <div id="functionsupporteddiv">
                    <select
                      class="mumbai"
                      v-model="functionSupported"
                      @change="onFunctionChange"
                    >
                      <option selected>-Select-</option>
                      <option
                        v-for="functionSupported in functionSupporteds"
                        v-bind:key="functionSupported.id"
                      >
                        {{ functionSupported }}
                      </option>
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <td><strong>Tasks Performed</strong></td>
                <td v-if="group === 'CORPORATE'">
                  <div
                    v-if="
                      functionSupported === 'Research' ||
                      functionSupported === 'Adhoc'
                    "
                    id="divTaskPerformed"
                  >
                    <td>
                      <input
                        class="mumbai"
                        type="text"
                        name="taskperformed"
                        size="29"
                        v-model="task_performed"
                      />
                    </td>
                  </div>
                  <div v-else id="divTaskPerformed">
                    <select class="mumbai" v-model="task_performed">
                      <option selected>-Select-</option>
                      <option
                        v-for="task_performed in task_performeds"
                        v-bind:key="task_performed.id"
                      >
                        {{ task_performed }}
                      </option>
                    </select>
                  </div>
                </td>

                <td v-else>
                  <div id="divTaskPerformed">
                    <select class="mumbai" v-model="task_performed">
                      <option selected>-Select-</option>
                      <option
                        v-for="task_performed in task_performeds"
                        v-bind:key="task_performed.id"
                      >
                        {{ task_performed }}
                      </option>
                    </select>
                  </div>
                </td>
                <td><strong>Analyst</strong></td>
                <td>
                  <combobox
                    :emails="emails"
                    :disabled="stockReportFlag"
                    class="mumbai"
                    type="email"
                    name="mumbaianalystid"
                    v-model="mumbaianalystid"
                    size="29"
                  ></combobox>
                </td>
              </tr>

              <tr>
                <td><strong>Date Range (MM-DD-YYYY)</strong></td>
                <td>
                  <div class="flex-container">
                    <DatePicker
                      v-model="range.start"
                      mode="date"
                      :masks="masks"
                      color="blue"
                    >
                      <template
                        class="flex-child"
                        v-slot="{ inputValue, isDragging, togglePopover }"
                      >
                        <input
                          class="reportDate"
                          :class="
                            isDragging ? 'text-gray-600' : 'text-gray-900'
                          "
                          :value="inputValue"
                        />
                        <svg
                          style="
                            padding: 0px;
                            margin-left: -24px;
                            margin-top: -1.8px;
                          "
                          @click="togglePopover()"
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="26"
                          fill="currentColor"
                          class="bi bi-calendar"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                          />
                        </svg>
                        <span>&ensp;</span>
                      </template>
                    </DatePicker>
                    <DatePicker
                      v-model="range.end"
                      mode="date"
                      :masks="masks"
                      color="blue"
                    >
                      <template
                        class="flex-child"
                        v-slot="{ inputValue, isDragging, togglePopover }"
                      >
                        <input
                          class="reportDate"
                          :class="
                            isDragging ? 'text-gray-600' : 'text-gray-900'
                          "
                          :value="inputValue"
                        />
                        <svg
                          style="
                            padding: 0px;
                            margin-left: -24px;
                            margin-top: -1.8px;
                          "
                          @click="togglePopover()"
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="26"
                          fill="currentColor"
                          class="bi bi-calendar"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                          />
                        </svg>
                      </template>
                    </DatePicker>
                  </div>
                </td>
                <td><strong>Feedback Score</strong></td>
                <td>
                  <select
                    :disabled="stockReportFlag"
                    class="mumbai"
                    v-model="selectedfdbscore"
                    id="feedbackscore"
                  >
                    <option
                      v-for="fdbscr in feedbackscoreArr"
                      v-bind:value="{ id: fdbscr.id, text: fdbscr.text }"
                      v-bind:key="fdbscr.id"
                    >
                      {{ fdbscr.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td><strong>Report Type</strong></td>
                <td>
                  <div>
                    <select
                      class="mumbai"
                      v-model="reportType"
                      @change="checkReportFlag"
                      required
                    >
                      <option selected>Overall Report</option>
                      <option
                        v-for="reportType in reportTypes"
                        v-bind:key="reportType.id"
                      >
                        {{ reportType }}
                      </option>
                    </select>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <button
            style="margin-top: 20px"
            type="submit"
            :disabled="isnotActive"
            v-on:click="downloadData"
          >
            Download Report
          </button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <button style="margin-top: 20px" v-on:click="resetData()">
            Reset
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import store from "@/store";
import moment from "moment";
import lodash from "lodash";
import { DatePicker } from "v-calendar";
import "v-calendar/dist/style.css";
import combobox from "@/reusableComponents/comboBox";
export default {
  components: {
    DatePicker,
    combobox,
  },
  name: "HelloWorld",
  setup() {
    return {
      store,
    };
  },
  props: { msg: String },
  data() {
    return {
      range: {
        start: new Date(
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        ),
        end: new Date(),
      },
      masks: {
        input: "MM-DD-YYYY",
      },
      Url: "reportData?",
      respReportUrl: "responseReportData",
      isnotActive: false,
      message: false,
      files: [],
      attach: [],
      feeddate: "",
      companyname: "",
      functionSupported: "-Select-",
      task_performed: "-Select-",
      usanalystid: "",
      mumbaianalystid: "",
      selecteddtrange: { id: 0, text: "-Select-" },
      selectedfdbscore: { id: 0, text: "-Select-" },
      group: "-Select-",
      funcsuppfilteredArr: [],
      taskperformfilteredArr: [],
      groupbydataArr: {},
      jsonresponse: [],
      groups: [],
      groupArr: ["CRS"],
      functionSupporteds: [],
      function_json: {
        CRS: ["Research"],
      },
      task_performeds: [],
      task_json: {
        CRS: { Research: ["Dealview", "Chronicale", "other"] },
      },
      dtrangeArr: [
        { id: 0, text: "-Select-" },
        { id: 1, text: "Last 1 Month" },
        { id: 3, text: "Last 3 Months" },
        { id: 6, text: "Last 6 Months" },
        { id: 12, text: "Last 12 Months" },
      ],
      feedbackscoreArr: [
        { id: 0, text: "-Select-" },
        { id: 1, text: "1" },
        { id: 2, text: "2" },
        { id: 3, text: "3" },
        { id: 4, text: "4" },
        { id: 5, text: "5" },
      ],
      objVal: {},
      reportTypes: [
        "Quality %",
        "Timeliness %",
        "Quality Average Score",
        "Response Rate %",
      ],
      reportType: "Overall Report",
      qualityJson: {},
      quality: {},
      timeliness: {},
      qualityAverageScore: {},
      stockReportFlag: true,
      emails: [],
      usAnalystFlag: false,
    };
  },
  async beforeCreate() {
    const getUrl = new URL(process.env.VUE_APP_BACKEND_API + "getEmails");
    this.groups = store.methods.getGroup();

    getUrl.searchParams.append("group", this.groups);

    const response = await axios
      .get(getUrl)
      .then((response) => (this.jsonresponse = response))
      .catch((error) => {
        this.errorMessage = error.message;
        console.error("There was an error!", error);
      });
    this.jsonresponse = response.data;
    this.emails = this.jsonresponse.map((data) => {
      return data["email"];
    });
  },
  created: function () {
    this.groups = store.methods.getGroup();

    if (this.groups.length === 1) {
      this.group = this.groups[0];

      this.functionSupporteds = Object.keys(this.task_json[this.group]);
      this.message = false;
    }
    this.checkReportFlag();
  },
  methods: {
    onGroupChange() {
      this.functionSupporteds = Object.keys(this.task_json[this.group]);
      this.message = false;
      this.onFunctionChange();
    },
    onFunctionChange() {
      this.task_performeds = this.task_json[this.group][this.functionSupported];

      if (this.task_performed) {
        this.task_performed = "-Select-";
      }
    },
    validateReport() {
      var flag = true;
      var message = "";
      if (this.range.end.getTime() < this.range.start.getTime()) {
        flag = false;
        message = "Please select correct date range";
      }

      if (this.usanalystid.length > 0) {
        if (!/@morningstar.com$/.test(this.usanalystid)) {
          flag = false;
          message = "Please enter 'morningstar' emailid for primary analyst";
        }
      }
      if (flag == false) {
        alert(message);
      }
      return flag;
    },
    checkReportFlag() {
      if (this.reportType !== "Overall Report") {
        this.mumbaianalystid = "";
        this.selectedfdbscore = { id: 0, text: "-Select-" };
        return (this.stockReportFlag = true);
      }
      return (this.stockReportFlag = false);
    },
    downloadTabularDataForResponseRate() {
      const url = new URL(process.env.VUE_APP_BACKEND_API + this.respReportUrl);
      if (this.groups.length > 1 && !this.group) {
        url.searchParams.append("group", this.selectedGroups);
        url.searchParams.append("startDate", this.formatDate(this.range.start));
        url.searchParams.append("endDate", this.formatDate(this.range.end));
        url.searchParams.append("reportType", this.reportType);
      } else {
        url.searchParams.append("group", this.group);
        url.searchParams.append("functionsupported", this.functionSupported);
        url.searchParams.append("tasksperformed", this.task_performed);
        url.searchParams.append("startDate", this.formatDate(this.range.start));
        url.searchParams.append("endDate", this.formatDate(this.range.end));
        url.searchParams.append("reportType", this.reportType);
      }

      const excelFileContentType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      // here we add 'Accept' header so lambda will return binary response
      const request = new Request(url, {
        method: "GET",
        headers: { Accept: excelFileContentType },
        credentials: "include",
      });
      fetch(request)
        .then((response) => {
          if (response.headers.get("content-length") > 0) {
            const reader = response.body.getReader();
            return new ReadableStream({
              start(controller) {
                return pump();
                function pump() {
                  return reader.read().then(({ done, value }) => {
                    // When no more data needs to be consumed, close the stream
                    if (done) {
                      controller.close();
                      return;
                    }
                    // Enqueue the next data chunk into our target stream
                    controller.enqueue(value);
                    return pump();
                  });
                }
              },
            });
          } else {
            throw new Error("No Data found !!!");
          }
        })
        .then((stream) => new Response(stream))
        // Create an object URL for the response
        .then((response) => response.blob())
        .then((blob) =>
          URL.createObjectURL(blob, { type: excelFileContentType }),
        )
        .then((fileURL) => {
          const today = new Date();
          const date =
            today.getFullYear() +
            "-" +
            (today.getMonth() + 1) +
            "-" +
            today.getDate();
          const time =
            today.getHours() +
            ":" +
            today.getMinutes() +
            ":" +
            today.getSeconds();
          const dateTime = date + "_" + time;
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            "TLF_Report_" + dateTime + "Response Rate %.xlsx",
          );
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isnotActive = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          alert(this.errorMessage);
          this.isnotActive = false;
        });
    },
    downloadData() {
      this.usAnalystFlag = this.emails.includes(
        this.mumbaianalystid.toLowerCase(),
      );

      if (this.validateReport()) {
        if (this.group === "-Select-") {
          this.group = "";
        }
        if (this.task_performed === "-Select-") {
          this.task_performed = "";
        }

        if (this.functionSupported === "-Select-") {
          this.functionSupported = "";
        }

        this.isnotActive = true;

        if (this.reportType === "" || this.reportType === "Overall Report") {
          if (this.usAnalystFlag || this.mumbaianalystid == "") {
            this.stockReport();
          } else {
            alert("Enter correct Analyst email id");
            this.isnotActive = false;
            this.mumbaianalystid = "";
          }
        } else {
          if (this.reportType === "Response Rate %") {
            this.downloadTabularDataForResponseRate();
          } else {
            this.downloadTabularData();
          }
        }
      }
    },
    stockReport() {
      const reportUri = new URL(process.env.VUE_APP_BACKEND_API + this.Url);
      if (this.groups.length > 1 && !this.group) {
        reportUri.searchParams.append("group", this.groups);
        reportUri.searchParams.append(
          "startDate",
          this.formatDate(this.range.start),
        );
        reportUri.searchParams.append(
          "endDate",
          this.formatDate(this.range.end),
        );
        reportUri.searchParams.append(
          "feedbackscore",
          this.selectedfdbscore.id,
        );
        reportUri.searchParams.append("reportType", this.reportType);
      } else {
        reportUri.searchParams.append("group", this.group);
        reportUri.searchParams.append(
          "functionsupported",
          this.functionSupported,
        );
        reportUri.searchParams.append("tasksperformed", this.task_performed);
        reportUri.searchParams.append("mumbaianalystid", this.mumbaianalystid);
        reportUri.searchParams.append(
          "startDate",
          this.formatDate(this.range.start),
        );
        reportUri.searchParams.append(
          "endDate",
          this.formatDate(this.range.end),
        );
        reportUri.searchParams.append(
          "feedbackscore",
          this.selectedfdbscore.id,
        );
        reportUri.searchParams.append("reportType", this.reportType);
      }
      axios
        .get(reportUri)
        .then((response) => {
          this.jsonresponse = response.data.reportData;

          if (this.jsonresponse != undefined && this.jsonresponse.length > 0) {
            var exportData = [];
            this.isnotActive = true;
            for (var j in this.jsonresponse) {
              var Obj = {
                "Request Id": this.jsonresponse[j]["requestId"],
                "Group Name": this.jsonresponse[j]["groupName"],
                "Task Performed": this.jsonresponse[j]["tasksPerformed"],
                "Company Name": this.jsonresponse[j]["companyName"],
                "Onshore Analyst Form Raised to":
                  this.jsonresponse[j]["usAnalystId"],
                "Date of Feedback form raised":
                  this.jsonresponse[j]["feedDate"],
                "Feedback received when":
                  this.jsonresponse[j]["feedReceivedDate"],
                "Mumbai Analyst": this.jsonresponse[j]["mumbaiAnalystId"],
                "Overall Feedback": this.jsonresponse[j]["overAllFeed"],
                "Any other comments": this.jsonresponse[j]["anyOtherComment"],
                Timeliness: this.jsonresponse[j]["timeliNess"],
              };
              exportData.push(Obj);
            }
            const today = new Date();
            const date =
              today.getFullYear() +
              "-" +
              (today.getMonth() + 1) +
              "-" +
              today.getDate();
            const time =
              today.getHours() +
              ":" +
              today.getMinutes() +
              ":" +
              today.getSeconds();
            const dateTime = date + "_" + time;

            const data = XLSX.utils.json_to_sheet(exportData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, data, "data");
            XLSX.writeFile(wb, "TLF_Report_" + dateTime + ".xlsx");
            this.isnotActive = false;
            this.resetData();
          } else {
            this.isnotActive = false;
            alert("No Data found !!!");
          }
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          this.isnotActive = false;
        });
    },
    qualityReport() {
      let res = this.jsonresponse;
      let resAlt = this.jsonresponse;
      let montharr = ["Group"];
      res.map((current) => {
        let month = current["feedReceivedDate"]
          ? moment(moment(current["feedReceivedDate"], "YYYY-MM-DD")).format(
              "MMMM YY",
            )
          : "";
        return (current["feedReceivedDate"] = month);
      });
      res.map((current) => {
        let month = current["feedDate"]
          ? moment(moment(current["feedDate"], "YYYY-MM-DD")).format("MMMM YY")
          : "";
        if (!montharr.includes(month) && month !== "") {
          montharr.push(month);
        }
        return (current["feedDate"] = month);
      });

      //filtering valid request
      res = lodash.filter(res, (current) => {
        return current["feedReceivedDate"] && parseInt(current["overAllFeed"]);
      });

      const reducedGrouped = lodash.groupBy(res, "feedDate");

      //try to bifurcate using groupname
      for (let a in reducedGrouped) {
        reducedGrouped[a] = lodash.groupBy(reducedGrouped[a], "groupName");
      }

      for (let a in reducedGrouped) {
        for (let i in reducedGrouped[a]) {
          reducedGrouped[a][i] = reducedGrouped[a][i].length;
        }
      }

      let filteredResponse = lodash.filter(resAlt, (current) => {
        return (
          current["feedReceivedDate"] && current["overAllFeed"] != "Not at par"
        );
      });

      const filteredreducedGrouped = lodash.groupBy(
        filteredResponse,
        "feedDate",
      );

      //try to bifurcate using groupname
      for (let a in filteredreducedGrouped) {
        filteredreducedGrouped[a] = lodash.groupBy(
          filteredreducedGrouped[a],
          "groupName",
        );
      }

      for (let a in filteredreducedGrouped) {
        if (!filteredreducedGrouped[a]) {
          filteredreducedGrouped[a] = {};
        }
        for (let i in filteredreducedGrouped[a]) {
          if (!filteredreducedGrouped[a][i]) {
            filteredreducedGrouped[a][i] = {};
          }
          filteredreducedGrouped[a][i] = filteredreducedGrouped[a][i].length;
        }
      }

      //Comparing objects to get total quality
      for (let a in reducedGrouped) {
        this.quality[a] = {};
        for (let i in reducedGrouped[a]) {
          this.quality[a][i] =
            filteredreducedGrouped[a] && filteredreducedGrouped[a][i]
              ? (filteredreducedGrouped[a][i] / reducedGrouped[a][i]) * 100
              : 0;
        }
      }

      let groups =
        this.groups.length > 1 && !this.group
          ? this.selectedGroups
          : this.groups;
      groups = groups.filter((group) => group != "All");

      let arr = [...Array(groups.length + 2)].map(() =>
        [...Array(montharr.length)].map(() => ""),
      );
      let count = [...Array(montharr.length)].map(() => 0);
      let sum = [...Array(montharr.length)].map(() => 0);

      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < montharr.length; j++) {
          if (!this.quality[montharr[j]]) {
            this.quality[montharr[j]] = 0;
          }

          if (i == 0) {
            arr[i][j] = montharr[j];
          } else if (j == 0) {
            arr[i][j] = i == arr.length - 1 ? "Grand Total" : groups[i - 1];
          } else if (i != arr.length - 1) {
            if (this.quality[montharr[j]][groups[i - 1]]) {
              arr[i][j] =
                this.quality[montharr[j]][groups[i - 1]].toFixed(2) + "%";
              count[j]++;
              sum[j] += this.quality[montharr[j]][groups[i - 1]];
            } else {
              arr[i][j] = "NA";
            }
          } else {
            arr[i][j] =
              count[j] != 0 ? (sum[j] / count[j]).toFixed(2) + "%" : "NA";
          }
        }
      }
      return arr;
    },
    timelinessReport() {
      let res = this.jsonresponse;
      const resAlt = this.jsonresponse;
      let montharr = ["Group"];
      res.map((current) => {
        let month = current["feedReceivedDate"]
          ? moment(moment(current["feedReceivedDate"], "YYYY-MM-DD")).format(
              "MMMM YY",
            )
          : "";
        return (current["feedReceivedDate"] = month);
      });
      res.map((current) => {
        let month = current["feedDate"]
          ? moment(moment(current["feedDate"], "YYYY-MM-DD")).format("MMMM YY")
          : "";
        if (!montharr.includes(month) && month !== "") {
          montharr.push(month);
        }
        return (current["feedDate"] = month);
      });

      //filtering valid request
      res = lodash.filter(res, (current) => {
        return current["feedReceivedDate"];
      });

      const reducedGrouped = lodash.groupBy(res, "feedDate");

      for (let a in reducedGrouped) {
        reducedGrouped[a] = lodash.groupBy(reducedGrouped[a], "groupName");
      }

      for (let a in reducedGrouped) {
        for (let i in reducedGrouped[a]) {
          reducedGrouped[a][i] = reducedGrouped[a][i].length;
        }
      }

      let filteredResponse = lodash.filter(resAlt, (current) => {
        return current["timeliNess"] === "Met" && current["feedReceivedDate"];
      });

      const filteredreducedGrouped = lodash.groupBy(
        filteredResponse,
        "feedDate",
      );

      //try to bifurcate using groupname
      for (let a in filteredreducedGrouped) {
        filteredreducedGrouped[a] = lodash.groupBy(
          filteredreducedGrouped[a],
          "groupName",
        );
      }

      for (let a in filteredreducedGrouped) {
        for (let i in filteredreducedGrouped[a]) {
          filteredreducedGrouped[a][i] = filteredreducedGrouped[a][i].length;
        }
      }

      //Comparing objects to get total timeliness
      for (let a in reducedGrouped) {
        this.timeliness[a] = {};
        for (let i in reducedGrouped[a]) {
          this.timeliness[a][i] =
            filteredreducedGrouped[a] && filteredreducedGrouped[a][i]
              ? (filteredreducedGrouped[a][i] / reducedGrouped[a][i]) * 100
              : 0;
        }
      }

      let groups =
        this.groups.length > 1 && !this.group
          ? this.selectedGroups
          : this.groups;
      groups = groups.filter((group) => group != "All");

      let count = [...Array(montharr.length)].map(() => 0);
      let sum = [...Array(montharr.length)].map(() => 0);

      let arr = [...Array(groups.length + 2)].map(() =>
        [...Array(montharr.length)].map(() => ""),
      );

      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < montharr.length; j++) {
          if (!this.timeliness[montharr[j]]) {
            this.timeliness[montharr[j]] = 0;
          }
          if (i == 0) {
            arr[i][j] = montharr[j] ? montharr[j] : 0;
          } else if (j == 0) {
            arr[i][j] = i == arr.length - 1 ? "Grand Total" : groups[i - 1];
          } else if (i != arr.length - 1) {
            if (this.timeliness[montharr[j]][groups[i - 1]]) {
              arr[i][j] =
                this.timeliness[montharr[j]][groups[i - 1]].toFixed(2) + "%";
              count[j]++;
              sum[j] += this.timeliness[montharr[j]][groups[i - 1]];
            } else {
              arr[i][j] = "NA";
            }
          } else {
            arr[i][j] =
              count[j] != 0 ? (sum[j] / count[j]).toFixed(2) + "%" : "NA";
          }
        }
      }
      return arr;
    },
    qualityAverageScoreReport() {
      let res = this.jsonresponse;
      let resAlt = this.jsonresponse;
      let montharr = ["Group"];
      //converted date to month
      res.map((current) => {
        let month = current["feedReceivedDate"]
          ? moment(moment(current["feedReceivedDate"], "YYYY-MM-DD")).format(
              "MMMM YY",
            )
          : "";

        return (current["feedReceivedDate"] = month);
      });
      res.map((current) => {
        let month = current["feedDate"]
          ? moment(moment(current["feedDate"], "YYYY-MM-DD")).format("MMMM YY")
          : "";
        if (!montharr.includes(month) && month !== "") {
          montharr.push(month);
        }
        return (current["feedDate"] = month);
      });

      res = lodash.filter(res, (current) => {
        return current["feedReceivedDate"] && parseInt(current["overAllFeed"]);
      });

      //grouped using feeddate
      const reducedGrouped = lodash.groupBy(res, "feedDate");

      //grouped using groupName
      for (let a in reducedGrouped) {
        reducedGrouped[a] = lodash.groupBy(reducedGrouped[a], "groupName");
      }

      resAlt = resAlt.map((current) => {
        if (current["overAllFeed"] === "Highly Satisfied") {
          current["overAllFeed"] = 5;
        } else if (current["overAllFeed"] === "Satisfied") {
          current["overAllFeed"] = 5;
        } else {
          current["overAllFeed"] = 5;
        }
        return current;
      });
      let filteredResponse = lodash.filter(resAlt, (current) => {
        return current["feedReceivedDate"];
      });

      const filteredreducedGrouped = lodash.groupBy(
        filteredResponse,
        "feedDate",
      );

      //try to bifurcate using groupname
      for (let a in filteredreducedGrouped) {
        filteredreducedGrouped[a] = lodash.groupBy(
          filteredreducedGrouped[a],
          "groupName",
        );
      }

      //Comparing objects to get total Average quality score
      for (let a in reducedGrouped) {
        this.qualityAverageScore[a] = {};

        if (!reducedGrouped[a]) {
          reducedGrouped[a] = 0;
        } else {
          for (let i in reducedGrouped[a]) {
            let sum = 0;
            if (filteredreducedGrouped[a] && filteredreducedGrouped[a][i]) {
              for (let j of filteredreducedGrouped[a][i]) {
                sum = sum + parseInt(j.overAllFeed);
              }
              this.qualityAverageScore[a][i] =
                sum / filteredreducedGrouped[a][i].length
                  ? parseFloat(
                      (sum / filteredreducedGrouped[a][i].length).toFixed(2),
                    )
                  : 0;
            }
          }
        }
      }

      let groups =
        this.groups.length > 1 && !this.group
          ? this.selectedGroups
          : this.groups;
      groups = groups.filter((group) => group != "All");

      let count = [...Array(montharr.length)].map(() => 0);
      let sum = [...Array(montharr.length)].map(() => 0);
      let arr = [...Array(groups.length + 2)].map(() =>
        [...Array(montharr.length)].map(() => ""),
      );

      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < montharr.length; j++) {
          if (!this.qualityAverageScore[montharr[j]]) {
            this.qualityAverageScore[montharr[j]] = 0;
          }
          if (i == 0) {
            arr[i][j] = montharr[j] ? montharr[j] : 0;
          } else if (j == 0) {
            arr[i][j] = i == arr.length - 1 ? "Grand Total" : groups[i - 1];
          } else if (i != arr.length - 1) {
            if (this.qualityAverageScore[montharr[j]][groups[i - 1]]) {
              arr[i][j] =
                this.qualityAverageScore[montharr[j]][groups[i - 1]].toFixed(2);
              count[j]++;
              sum[j] += this.qualityAverageScore[montharr[j]][groups[i - 1]];
            } else {
              arr[i][j] = "-";
            }
          } else {
            arr[i][j] = count[j] != 0 ? (sum[j] / count[j]).toFixed(2) : "NA";
          }
        }
      }

      return arr;
    },
    downloadTabularData() {
      const reportTableUri = new URL(
        process.env.VUE_APP_BACKEND_API + this.Url,
      );

      if (this.groups.length > 1 && !this.group) {
        reportTableUri.searchParams.append("group", this.selectedGroups);
        reportTableUri.searchParams.append(
          "startDate",
          this.formatDate(this.range.start),
        );
        reportTableUri.searchParams.append(
          "endDate",
          this.formatDate(this.range.end),
        );
        reportTableUri.searchParams.append("reportType", this.reportType);
      } else {
        reportTableUri.searchParams.append("group", this.group);
        reportTableUri.searchParams.append(
          "functionsupported",
          this.functionSupported,
        );
        reportTableUri.searchParams.append(
          "tasksperformed",
          this.task_performed,
        );
        reportTableUri.searchParams.append(
          "startDate",
          this.formatDate(this.range.start),
        );
        reportTableUri.searchParams.append(
          "endDate",
          this.formatDate(this.range.end),
        );
        reportTableUri.searchParams.append("reportType", this.reportType);
      }
      axios
        .get(reportTableUri)
        .then((response) => {
          this.jsonresponse = response.data.reportData;

          if (this.jsonresponse != undefined && this.jsonresponse.length > 0) {
            var exportData = [];
            this.isnotActive = true;
            let reportTypeAppend = "";
            let tabName = "";
            switch (this.reportType) {
              case "Quality %":
                exportData = this.qualityReport();
                reportTypeAppend = "_Qlty%";
                tabName = "Qlty%";
                break;
              case "Timeliness %":
                exportData = this.timelinessReport();
                reportTypeAppend = "_Timeliness%";
                tabName = "Timeliness%";
                break;
              case "Quality Average Score":
                exportData = this.qualityAverageScoreReport();
                reportTypeAppend = "_Avg_Qlty_Score";
                tabName = "_Avg_Qlty_Score";
                break;
            }

            const today = new Date();
            const date =
              today.getFullYear() +
              "-" +
              (today.getMonth() + 1) +
              "-" +
              today.getDate();
            const time =
              today.getHours() +
              ":" +
              today.getMinutes() +
              ":" +
              today.getSeconds();
            const dateTime = date + "_" + time;

            const data = XLSX.utils.aoa_to_sheet(exportData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, data, tabName);
            XLSX.writeFile(
              wb,
              "TLF_Report_" + dateTime + reportTypeAppend + ".xlsx",
            );
            this.isnotActive = false;
            if (this.group.length === 1) {
              this.resetData();
            }
          } else {
            this.isnotActive = false;
            alert("No Data found !!!");
          }
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          this.isnotActive = false;
        });
    },
    resetData() {
      this.mumbaianalystid = "";
      this.range = {
        start: new Date(
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        ),
        end: new Date(),
      };
      this.groups = store.methods.getGroup();
      if (this.groups.length > 1) {
        this.group = "-Select-";
      }

      this.functionSupported = "-Select-";
      this.task_performed = "-Select-";
      this.selecteddtrange = { id: 0, text: "-Select-" };
      this.selectedfdbscore = { id: 0, text: "-Select-" };
      this.isnotActive = false;
    },
    clearfunction() {
      this.funcsuppfilteredArr = [];
      var defaultObj = { id: 0, text: "-Select-" };
      this.funcsuppfilteredArr.push(defaultObj);
      this.functionSupported = "";
    },
    cleartask() {
      this.taskperformfilteredArr = [];
      var defaultObj = { id: 0, text: "-Select-" };
      this.taskperformfilteredArr.push(defaultObj);
      this.task_performed = { id: 0, text: "-Select-" };
      this.mumbaianalystid = "";
      this.task_performed = "";
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
  },
};
</script>

<style scoped>
* {
  font-family:
    "Univers", HelveticaNeue, "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.select-editable {
  position: relative !important;
  background-color: white !important;
  border: solid grey 1px !important;
  width: 273px !important;
  height: 18px !important;
}

.select-editable select {
  position: absolute !important;
  top: 0px !important;
  left: 0px !important;
  border: none !important;
  width: 273px !important;
  margin: 0 !important;
  border-bottom: solid grey 1px !important;
  border-right: solid grey 1px !important;
  border-left: solid grey 1px !important;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

.select-editable input {
  position: absolute !important;
  top: 0px !important;
  left: 0px !important;
  width: 100px !important;
  padding: 1px !important;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: none !important;
  border-bottom: solid grey 1px !important;
  border-right: solid grey 1px !important;
  border-left: solid grey 1px !important;
}

.select-editable select:focus,
.select-editable input:focus {
  outline: none !important;
}

.tooltip1 {
  width: 90%;
  height: 200px;
  visibility: hidden;
  background-color: #fff;
  padding: 20px;
  -webkit-box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.5s ease;
  position: absolute;
  top: 60%;
  left: 5%;
  z-index: 1;
}

#commentdiv {
  cursor: pointer;
}

#mumbai_div {
  margin-left: 20px;
}

#mumbai_title {
  text-align: left;
}
.mumbai {
  width: 273px;
  margin-top: 10px;
  height: 25px;
}
.reportDate {
  width: 136px;
  margin-top: 10px;
  height: 25px;
}

input[type="file"] {
  position: absolute;
  top: -500px;
}

span.remove-file {
  color: red;
  cursor: pointer;
  float: right;
}

.grayout {
  opacity: 0.6; /* Real browsers */
  filter: alpha(opacity = 60); /* MSIE */
}

.flex-container {
  display: flex;
}

.flex-child {
  flex: 1;
}
</style>
